import React, { useState, useEffect, useRef } from "react";
import { Modal, Button } from "./";
import ReactTooltip from "react-tooltip";
import { mediaApi } from "../../api/MediaApi";
import "./MediaUploader.scss";

export const MediaUploader = ({
  id,
  media,
  onChange,
  disabled,
  disabledTooltip,
}) => {
  const inputFile = useRef();
  const [preview, setPreview] = useState(false);
  const [mediaURL, setMediaURL] = useState("");
  const [videoURL, setVideoURL] = useState("");
  const [mediaFile, setMediaFile] = useState();
  const [mediaType, setMediaType] = useState();
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  useEffect(() => {
    // console.log("media", media);
    if (media?.photo) {
      setMediaType("image");
      setMediaURL(media.photo);
    }
    if (media?.thumb) {
      setMediaURL(media.thumb);
      setVideoURL(media.video_720p);
      setMediaType("video");
    }
  }, [media]);

  const onChangeFile = async (e) => {
    if (!e.target.files[0]) return;
    // console.log(e.target.files[0]);
    const url = URL.createObjectURL(e.target.files[0]);
    setUploading(false);
    setUploadProgress(0);
    setMediaURL(url);
    if (e.target.files[0].type.startsWith("video")) {
      setMediaType("video");
      setVideoURL(url);
    } else {
      setMediaType("image");
      setVideoURL(null);
    }
    setMediaFile(e.target.files[0]);
  };

  const onCancel = () => {
    inputFile.current.value = null;
    setMediaFile(null);
    setMediaURL(media?.photo || media?.thumb);
    setPreview(false);
    setUploading(false);
    setUploadProgress(0);
  };

  const onRemoveMedia = (e) => {
    e.stopPropagation();
    setMediaFile(null);
    setMediaURL(null);
    setVideoURL(null);
    onChange(null);
  };

  const onUploadClick = async () => {
    setUploading(true);
    let uploadedMedia = await mediaApi.uploadMedia(mediaFile);
    // console.log("uploadMedia", uploadedMedia);
    let progress = uploadedMedia.encoding_complete ? 1 : uploadedMedia.encoding_progress;

    const updateStat = async () => {
      uploadedMedia = await mediaApi.getMedia(uploadedMedia.id);
      // console.log("getMedia", uploadedMedia);
      if (uploadedMedia.encoding_progress > progress) {
        progress = uploadedMedia.encoding_progress;
        setUploadProgress(uploadedMedia.encoding_progress);
      }
      if (uploadedMedia.encoding_complete) {
        onChange(uploadedMedia);
        setPreview(false);
      } else {
        setTimeout(updateStat, 1000);
      }
    };

    if (uploadedMedia.encoding_complete) {
      onChange(uploadedMedia);
      setPreview(false);
    } else {
      updateStat();
    }
  };

  const onOpenUploader = () => {
    if (disabled && !media?.photo) return;
    if (media?.photo) {
      setMediaURL(media.photo);
    }
    setUploading(false);
    setUploadProgress(0);
    setPreview(true);
  };

  const allowUpload = () => {
    const isAllow = mediaFile && mediaURL !== media?.photo && mediaURL !== media?.thumb && !uploading;
    return isAllow;
  };

  const inputId = `media-uploader-file-${id}`;
  const tooltipId = `media-uploader-file-tooltip-${id}`;

  return (
    <div className="media-uploader">
      <span data-tip data-for={disabled ? tooltipId : ""}>
        <div className="open-btn" onClick={onOpenUploader}>
          {!mediaURL && (
            <div className="btn-only">
              <i className="material-icons">image</i>
            </div>
          )}
          {mediaURL && (
            <div className="thumbnail">
              <img src={mediaURL} width="50" height="50" alt="Question media" />
              {!disabled && (
                <div className="delete-btn" onClick={onRemoveMedia}>
                  <i className="material-icons">close</i>
                </div>
              )}
            </div>
          )}
        </div>
      </span>
      <ReactTooltip id={tooltipId} disable={!disabled}>
        {disabledTooltip}
      </ReactTooltip>
      {preview && (
        <Modal
          isOpen={preview}
          onClose={onCancel}
          onMouseOver={(e) => e.preventDefault()}
        >
          <div className="dialog">
            <h3 className="title">{disabled ? "" : "Question Media"}</h3>
            <label htmlFor={inputId}>
              <input
                type="file"
                id={inputId}
                name={inputId}
                ref={inputFile}
                accept="image/*,video/*"
                onChange={onChangeFile}
                disabled={disabled}
              />
              {mediaURL ? (
                <div className="media-preview">
                  {mediaType === "image" && <img src={mediaURL} alt="Question media" />}
                  {mediaType === "video" && (
                    <video width="480" height="270" controls>
                      <source
                        src={videoURL}
                        type={mediaFile?.type || "video/mp4"}
                      />
                      Your browser does not support video preview.
                    </video>
                  )}
                  {!disabled && (
                    <div className="img-actions">
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={() => inputFile.current.click()}
                      >
                        Change
                      </button>
                    </div>
                  )}
                </div>
              ) : (
                <div className="media-select">
                  <button
                    className="btn btn-primary"
                    onClick={() => inputFile.current.click()}
                  >
                    Choose image or video
                  </button>
                  <div>
                    <i className="material-icons">video_camera_back</i>
                  </div>
                  <p className="hint">
                    <strong>
                      Hint: The best video length to engage participants is
                      30-45 seconds.
                    </strong>
                    <br />
                    Video must be .mp4, .mov, .avi, .webm or .wmv and less than
                    600MB.
                  </p>
                </div>
              )}
            </label>
            {!disabled && (
              <div className="actions">
                {/* <button className="btn btn-danger" onClick={() => {}}>
                Remove
              </button>
              <div className="spacer"></div> */}
                <Button cancel onClick={onCancel}>
                  Cancel
                </Button>
                <Button
                  submit
                  onClick={onUploadClick}
                  disabled={!allowUpload()}
                >
                  {uploading
                    ? `Uploading ... (${(uploadProgress * 100).toFixed(0)}%)`
                    : "Upload"}
                </Button>
              </div>
            )}
          </div>
        </Modal>
      )}
    </div>
  );
};

export default MediaUploader;
